import React from "react";
import { ModalCloseIcon } from "@assets";
import styles from "../GeniusRegistrationModal.module.css";

export const RegistrationShell = ({
  title,
  subtitle,
  onClose,
  children,
  wide = false,
  centerTitle = false
}) => (
  <div className={`${styles.panel} ${wide ? styles.panelWide : ""}`} role="dialog" aria-modal="true">
    <button type="button" className={styles.closeButton} onClick={onClose} aria-label="Close">
      <img src={ModalCloseIcon} alt="" />
    </button>
    {title ? (
      <h2 className={`${styles.title} ${centerTitle ? styles.titleCenter : ""}`}>{title}</h2>
    ) : null}
    {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
    <div className={styles.body}>{children}</div>
  </div>
);
